export enum DashboardEvents {
  WelcomeView = 'WelcomeView',
  WelcomeSlideView = 'WelcomeSlideView',
  WelcomeSkip = 'WelcomeSkip',
  WelcomeEnd = 'WelcomeEnd',
}
